/* eslint-disable eqeqeq */

import {
  AbsoluteCenter,
  Box,
  Button,
  Divider,
  Flex,
  FormLabel,
  Heading,
  Stack,
  Text,
  chakra,
} from "@chakra-ui/react";

import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  forgetpasswordOtpUserAction,
  otpUserAction,
  resendOtpUserAction,
} from "../../../modules/auth/Actions";

import * as Yup from "yup";

const OtpForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isLoading = useSelector((state) => state.auth.isLoading);

  const otpSchema = Yup.object().shape({
    code: Yup.string().required("Required"),
  });
  const formik = useFormik({
    initialValues: {},
    validationSchema: otpSchema,
    onSubmit: (values) => {
      pathname.includes("forget-password")
        ? dispatch(
            forgetpasswordOtpUserAction({
              ...values,
              user_id: localStorage.getItem("userID"),
            })
          )
        : dispatch(
            otpUserAction({
              ...values,
              user_id: localStorage.getItem("userID"),
            })
          );
    },
  });

  return (
    <div dir="rtl" style={{ width: "60%", alignSelf: "center" }}>
      <form onSubmit={formik.handleSubmit}>
        <Flex
          flexDirection="column"
          w="100%"
          gap={8}
          fontFamily="sans-serif"
          boxShadow="0 0 16px 0 rgba(0, 0, 0, 0.16)"
          p={6}
          borderRadius={16}
        >
          <Heading mb="10px" color="main_1">
            محتاجين البيانات دي للتسجيل معانا
          </Heading>
          <Stack
            flexDirection="row"
            gap={10}
            justifyContent="center"
            alignItems="center"
          >
            <Box w="100%">
              <Flex alignItems="center">
                <FormLabel
                  htmlFor="code"
                  className="form-label "
                  color="main_1"
                  fontSize="22px"
                  fontWeight="500"
                >
                  ادخل الكود<span style={{ color: "red" }}>*</span>
                </FormLabel>
              </Flex>

              <input
                style={{
                  width: "50%",
                  padding: "10px",
                  objectFit: "contain",
                  borderRadius: "10px",
                  boxShadow: "inset 0 0 16px 0 rgba(0, 0, 0, 0.16)",
                  border: "solid 1px #0100108",
                  backgroundColor: "#fff",
                }}
                name="code"
                onChange={formik.handleChange}
                value={formik.values.code}
              />
              {formik?.errors.code && formik?.touched.code && (
                <Text color="red">{formik?.errors.code}</Text>
              )}
            </Box>
          </Stack>
          <Box
            onClick={() =>
              dispatch(
                resendOtpUserAction({ user_id: localStorage.getItem("userID") })
              )
            }
            textDecoration="underline"
            cursor="pointer"
          >
            <Text color="black" fontSize="22px">
              ابعت الكود تاني!
            </Text>
          </Box>
          <Button
            mt="40px"
            type="submit"
            w="250px"
            p="22px"
            alignSelf={"center"}
            isLoading={isLoading}
            bg="main_1"
            color="white"
          >
            أرسال الكود
          </Button>
        </Flex>
      </form>

      <Box position="relative" py="8">
        <Divider />
        <AbsoluteCenter color="black" px="4">
          أو
        </AbsoluteCenter>
      </Box>

      <Text color="black" textAlign="center" fontSize="22px">
        عندك حساب!
        <chakra.span
          color="main_1"
          fontWeight={600}
          px={2}
          cursor="pointer"
          textDecoration="underline"
          onClick={() => navigate("/login")}
        >
          تسجيل دخول
        </chakra.span>
      </Text>
    </div>
  );
};

export default OtpForm;
